import { render, staticRenderFns } from "./ModerateContent.vue?vue&type=template&id=286ac7a2&scoped=true&"
import script from "./ModerateContent.vue?vue&type=script&lang=js&"
export * from "./ModerateContent.vue?vue&type=script&lang=js&"
import style0 from "./ModerateContent.vue?vue&type=style&index=0&id=286ac7a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ac7a2",
  null
  
)

export default component.exports